export default "__VITE_ASSET__2m8_$KNH__"